var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.875,
    height: 18,
    viewBox: "0 0 17.875 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,7V6.8c0-1.4-.8-2.8-2.4-4.4S12.6,0,11.2,0H11c-.1,0-.1.1-.2.1A4.067,4.067,0,0,0,9.6,3.9L7.1,6.5a4.226,4.226,0,0,0-4.7.7c-.6.6-.6,1.6.2,2.9A23.07,23.07,0,0,0,4,12L.2,17.2a.629.629,0,0,0,0,.6c0,.2.2.2.3.2a.367.367,0,0,0,.3-.1L6,14.1c1.3,1.1,2.6,2,3.7,2a1.5,1.5,0,0,0,1.1-.4,4,4,0,0,0,1.1-2.9,5.33,5.33,0,0,0-.4-1.9L14,8.4c.3,0,.5.1.8.1a4.157,4.157,0,0,0,3-1.3C17.9,7.1,17.9,7,18,7Zm-1.1-.8a7.778,7.778,0,0,1-3.1-2,9.431,9.431,0,0,1-2-3.1,7,7,0,0,1,3.1,2A5.83,5.83,0,0,1,16.9,6.2Zm-14.1,9,1.8-2.5c.1.1.3.2.4.3l.3.3Zm7.3-.3c-.6.6-2.4-.5-4.5-2.6A15.172,15.172,0,0,1,3.4,9.6c-.3-.5-.7-1.4-.3-1.7a3.157,3.157,0,0,1,3.4-.5c-.1.2,0,.5.1,1a4.092,4.092,0,0,0,1.3,1.8,3.987,3.987,0,0,0,2.5,1.4h.3a3.548,3.548,0,0,1,.3,1.3A3.746,3.746,0,0,1,10.1,14.9Zm.4-4.4c-.1.1-.8,0-1.9-1.1C7.4,8.2,7.5,7.6,7.5,7.5L10,5a6.57,6.57,0,0,0,1.2,1.7,5.347,5.347,0,0,0,1.7,1.2Zm1.4-4.4c-1.6-1.6-1.6-3.2-1-4.4A9.348,9.348,0,0,0,13,4.9,10.132,10.132,0,0,0,16.3,7C15.2,7.7,13.6,7.7,11.9,6.1Z",
    transform: "translate(-0.125)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pin.010ee4b1182af57b568cd0400013f5e2.svg";